import SyNavPath from "./sy-nav-path";

export default SyNavPath